// extracted by mini-css-extract-plugin
module.exports =  {"products":"xBgZR","emptyPage":"_5I7ae"};